import EventBus from '../../../../shared/js/wirebox/event-bus'
import '../../../../shared/js/wirebox/modules/storage'
import jQuery from 'jquery'
import '../../components/maps'
import MarkerClusterer from '@googlemaps/markerclustererplus'
import {default as Bookmarks} from './bookmarks'

class FundersMap {
    
    /**
     * Construct component
     * @param container
    */
    constructor(container) {
        
        /**
         * Map container
         * @type object
        */
        this.container = container
        
        /**
         * Storage key
         * @type string
        */
        this.key = 'funders-map'
        
        /**
         * Google map
         * @type object
        */
        this.map = null
        
        this.bindEvents()
        
    }
    
    /**
     * Map created
     * @param event
     * @param map
    */
    mapCreated(event, map) {
        
        //Store map object
        this.map = map
        
        //Check whether up-to-date Funders are saved in local storage
        EventBus.publish('storage.read', {
            key: this.key,
            callback: (value) => {
                
                if (value) {
                    
                    //Convert stored string to object
                    const data = JSON.parse(value)
                    
                    //Continue only if stored update time matches value from server
                    if (data.time == fundersUpdatedTime) {
                        this.setupMarkers(data.funders)
                        return
                    }
                    
                }
                    
                //Load funders
                this.loadFunders()
                    
            }
        })
        
    }
    
    /**
     * Load Funders
    */
    loadFunders() {
        jQuery.post(this.container.data('url'), (funders) => {
            
            //Save funders in storage
            EventBus.publish('storage.write', {
                key: this.key,
                value: JSON.stringify({
                    funders: funders,
                    time: fundersUpdatedTime
                })
            })
            
            //Setup markers
            this.setupMarkers(funders)
            
        })
    }
    
    /**
     * Setup markers
     * @param funders
    */
    setupMarkers(funders) {
        
        //Bookmarked logic
        if (isBookmarks) {
            
            const newFunders = {}
            
            jQuery.each(funders, (id, funder) => {
                if (Bookmarks.has(id)) {
                    newFunders[id] = funder
                }
            })
            
            funders = newFunders
            
        }
        
        //Construct markers
        EventBus.publish('construct-map-markers', {
            positions: funders,
            map: this.map,
            callback: (markersObj) => {
                
                //Convert markers object to array
                const markers = []
                jQuery.each(markersObj, (id, marker) => {
                    
                    //Add ID to marker
                    marker.id = funders[id].slug
                    
                    //Add marker to array
                    markers.push(marker)
                    
                    //Bind click on marker
                    marker.addListener('click', () => {
                        window.location = funderUrl.replace('-1', marker.id)
                    })
                    
                })
                
                //Create cluster
                new MarkerClusterer(this.map, markers, {
                    styles: [
                      MarkerClusterer.withDefaultStyle({
                            anchorText: [-4, 0],
                            width: 70,
                            height: 70,
                            url: markerUrl,
                            textColor: '#fff',
                            textSize: 18
                        })
                    ]
                })
                
            }
        })
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Bind map created event
        this.container.on('map.created', this.mapCreated.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    const container = jQuery('#funders-map')
    
    if (container.length > 0) {
        new FundersMap(container)
    }
    
})

export default FundersMap